import React, { useContext, useState, useEffect } from 'react';
import { AppContext, AuthContext } from 'Context';
import { axios, dataFetcher, endpoints, baseUrl, cloudBaseUrl } from 'Api';
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import cn from 'classnames';
import { Page } from 'Components';
import { Pathname } from 'Routes';
import CustomButton from 'Components/button/CustomButton';
import { Tab, Tabs } from '@material-ui/core';
import {
  List,
  ListItemButton,
  Collapse,
  ListItemText,
  Box,
  ListItemIcon,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import Pencil from '../../../../../Assets/pencil.png';
import CreateCategoryPage from '../../../content-layout/CreateCategory';
import styles from './index.module.css';
import Sidebar from '../../SideBar/SideBar';
import TutorialCloud from '../../cloud/TutorialCloud';
import FilterTags from '../../cloud/FilterTags';

export const StoragePage = ({
  selected,
  setSelected,
  children,
  title,
  addActionName,
  link,
  subTitle,
  restricted,
}) => {
  const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    customStyleOnTab: {
      fontSize: '28px',
      color: '#95969A',
      fontWeight: 700,
      textTransform: 'capitalize',
    },
    activeTab: {
      fontSize: '28px',
      color: '#02071A',
      fontWeight: 700,
      textTransform: 'capitalize',
    },
  }));
  const classes = useStyles();
  const {
    langText,
    setTopOrBottom,
    storageSelectedType,
    setStorageSelectedType,
    storageSearchTerm,
    setStorageSearchTerm,
    storageSelectedDate,
    setStorageSelectedDate,
    storageTabTitle,
    setStorageTabTitle,
    storageSelectedItems,
    setStorageSelectedItems,
    setCloudToken,
    cloudToken,
  } = useContext(AppContext);
  const { getToken } = useContext(AuthContext);
  const { category, albumid } = useParams();
  const navigate = useNavigate();
  const handleTabChange = (event, newValue) => {
    setStorageTabTitle(newValue);
    setStorageSelectedItems([]);
  };
  const getCloudToken = async () => {
    try {
      const response = await axios.post(
        `${cloudBaseUrl}/auth/get-token/`,
        {
          token: getToken(),
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log('Response:', response.data);
      setCloudToken(response.data);
    } catch (error) {
      console.error('Error:', error.response?.data || error.message);
    }
  };
  const [openTutorailModal, setOpenTutorailModal] = React.useState(false);
  useEffect(() => {
    if (localStorage.getItem('tutorialCloud') === true) {
      setOpenTutorailModal(true);
    }
    if (!cloudToken?.access) {
      getCloudToken();
    }
    setTopOrBottom(true);
    return () => {
      setTopOrBottom(false); // Set topOrBottom to false when leaving the component
    };
  }, []);
  const sideBarText = langText?.storageSideBar;
  const [isMouseOver, setMouseOver] = useState(false);
  // const [selectedType, setSelectedType] = useState('name');
  // const [searchTerm, setSearchTerm] = useState('');
  // const [selectedDate, setSelectedDate] = useState('');
  const sidebarLinks = [
    // { name: (sideBarText?.cloudSidebarTitle || 'Cloud'), link: Pathname.getStoragePath(Pathname.storage.cloud) },
    {
      name: sideBarText?.cloudSidebarVideo || 'Videos',
      link: Pathname.getStoragePath(Pathname.storage.cloud),
    },
    {
      name: sideBarText?.cloudSidebarPhotos || 'Photos',
      link: Pathname.getStoragePath(Pathname.storage.cloud),
    },
  ];
  return (
    <Page
      contentClassName={restricted ? styles.pageContentRes : styles.pageContent}
      headerTheme={styles.headerTheme}
    >
      <TutorialCloud
        openTutorailModal={openTutorailModal}
        setOpenTutorailModal={setOpenTutorailModal}
      />
      <div className={styles.settingsPage}>
        {/* <Sidebar /> */}
        <div className={styles.contentWrapper} style={{ paddingTop: 0 }}>
          {/* <div className={styles.headingWrapper}>
            <div className={styles.headingWrapperInner}>
              <span className={styles.titleWrapper}>
                <span
                  className={cn({
                    [styles.pageTitle]: true,
                    [styles.restrictedPageTitle]: restricted,
                  })}
                >
                  {subTitle ? `${title}:   ` : title}
                </span>
                {(category || albumid) && (
                  <ListItemIcon
                    onClick={() => navigate(
                        category
                          ? `/content-layout/1/${category}`
                          : `/content-layout/3/${albumid}`
                      )}
                    sx={{ minWidth: 0, ml: 1, cursor: 'pointer' }}
                  >
                    <Box
                      component="img"
                      src={Pencil}
                      alt="Edit"
                      sx={{ width: 16, height: 16 }}
                    />
                  </ListItemIcon>
                )}
              </span>
              {title === 'Google Photos' ? (
                <FilterTags
                  selected={selected}
                  setSelected={setSelected}
                  onChange={(selectedTypes) => {
                    console.log('Selected:', selectedTypes);
                  }}
                />
              ) : (
              <div className={styles.search}>
                <div className={styles.searchInner}>
                  <select
                    onChange={(e) => {
                      setStorageSelectedType(e.target.value);
                      setStorageSearchTerm('');
                      setStorageSelectedDate('');
                    }}
                  >
                    <option value="name">By Name</option>
                    <option value="date">By Date</option>
                  </select>
                  <input
                    type={storageSelectedType === 'name' ? 'text' : 'date'}
                    placeholder={
                      storageSelectedType === 'name' ? 'Eg: Family photo' : ''
                    }
                    value={
                      storageSelectedType === 'name'
                        ? storageSearchTerm
                        : storageSelectedDate
                    }
                    onChange={(e) => {
                      if (storageSelectedType === 'name') {
                        setStorageSearchTerm(e.target.value);
                      } else {
                        setStorageSelectedDate(e.target.value);
                      }
                    }}
                  />
                </div>
              </div>
              )}
              <div>
                <div className={styles.createCate}>
                  <CreateCategoryPage />
                </div>
              </div>
            </div>
          </div> */}
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </Page>
  );
};
